<template>
  <div>
    <div class="space-between align-center">
      <div class="align-center flex-1">
        <div class="filter-icon">
          <img src="/img/filter.svg" alt="" />
        </div>

        <div class="search-wrappper">
          <b-input-group size="sm">
            <b-form-input v-model="filter" placeholder="Search here...">
            </b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <button
        type="button"
        class="btn mulai btn-secondary font-bold"
        @click="handleNew"
      >
        <fa-icon icon="edit" class="my-icon" />&nbsp; ADD NEW SUBJECT
      </button>
    </div>
    <br />
    <br />
    <!-- Main table element -->
    <b-table
      show-empty
      stacked="md"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template #cell(icon)="row">
        <p>
          <fa-icon :icon="row.item.icon" class="my-icon" />
        </p>
      </template>

      <template #cell(actions)="row">
        <b-button
          size="sm"
          class="mr-3 mb-2 action-button"
          variant="outline-secondary"
          @click="handleEdit(row.item)"
        >
          <fa-icon icon="pencil-alt" />&nbsp;Edit
        </b-button>
      </template>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <b-modal
      v-model="addModal"
      id="addModal"
      hide-header
      hide-footer
      centered
    >
      <modal-cross @close="addModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">{{editData ? "Edit Subject" : "Create New Subject"}}</h3>
        <br />

        <label>Subject Name</label>
        <br />
        <b-form-input
          v-model="inputData.name"
          placeholder="Enter name..."
        ></b-form-input>
        <br />

        <label>Icon</label>
        <br />
        <b-form-input
          v-model="inputData.icon"
          placeholder="Select icon..."
        ></b-form-input>
        <br/>
        <b-form-radio v-model="inputData.icon" v-for="(itm, idx) in icons" 
          :value="itm.value" :key="'opt-'+idx"
          style="display: inline-block; margin-right: 30px">
          <fa-icon :icon="itm.value" style="width: 20px;"/>
        </b-form-radio>
        <br />
        <br />

        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="handleSave"
          >
            SAVE
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      icons: [
        { text: 'square-root-alt', value: 'square-root-alt' }, 
        { text: 'mosque', value: 'mosque' }, 
        { text: 'quran', value: 'quran' }, 
        { text: 'medal', value: 'medal' }, 
        { text: 'history', value: 'history' }, 
        { text: 'language', value: 'language' }, 
        { text: 'palette', value: 'palette' }, 
        { text: 'dumbbell', value: 'dumbbell' }, 
        { text: 'lightbulb', value: 'lightbulb' }, 
        { text: 'leaf', value: 'leaf' }, 
        { text: 'atom', value: 'atom' }, 
        { text: 'bong', value: 'bong' }
      ],
      items: [],
      fields: [
        {
          key: "id",
          label: "#ID", 
          sortable: true,
          sortDirection: "asc"
        },
        {
          key: "name",
          label: "Subject Name",
          sortable: true
        },
        {
          key: "icon",
          label: "Icon",
          sortable: false
        },
        {
          key: "actions",
          label: "Action"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      isBusy: false,
      editData: false,
      addModal: false,
      inputData: {
        id: 0,
        name: "",
        icon: ""
      },
      showLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn"
    })
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.push("/login");
    }
  },
  mounted() {
    this.totalRows = this.items.length;
    this.subjectList();
  },
  methods: {
    ...mapActions({
      classroomSubjectList: types.CLASSROOM_SUBJECT_LIST,
      classroomSubjectCreate: types.CLASSROOM_SUBJECT_CREATE,
      classroomSubjectUpdate: types.CLASSROOM_SUBJECT_UPDATE,
    }),
    subjectList() {
      this.isBusy = true;
      this.classroomSubjectList()
      .then(response => {
        this.items = response;
        this.totalRows = response.length;
        this.isBusy = false;
      })
      .catch(error => {
        this.showMessageBox(error, "Failed", "success");
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleNew() {
      this.addModal = true;
      this.editData=false;
      this.inputData = {
        id: 0,
        name: "",
        icon: ""
      }
    },
    handleEdit(item) {
      this.addModal = true;
      this.editData = true;
      this.inputData = {
        id: item.id,
        name: item.name,
        icon: item.icon
      }
    },
    handleSave() {
      if(this.inputData.name && this.inputData.icon) {
        if(this.editData) {
          this.editSubject();
        } else {
          this.addSubject();
        }
      } else {
        this.showMessageBox('Please input all data', 'Empty Data', 'danger')
      }
    },
    addSubject() {
      this.showLoading = true;

      var payload = {
        name: this.inputData.name, 
        icon: this.inputData.icon
      }

      this.classroomSubjectCreate(payload)
      .then(response => {
        // eslint-disable-next-line
        var res = response;
        this.addModal = false;
        this.showLoading = false;
        this.subjectList();
      })
      .catch(error => {
        this.showLoading = false;
        this.showMessageBox(error, "Failed", "success");
      });
    },
    editSubject() {
      this.showLoading = true;

      var payload = {
        id: this.inputData.id,
        name: this.inputData.name, 
        icon: this.inputData.icon
      }

      this.classroomSubjectUpdate(payload)
      .then(response => {
        // eslint-disable-next-line
        var res = response;
        this.addModal = false;
        this.showLoading = false;
        this.subjectList();
      })
      .catch(error => {
        this.showLoading = false;
        this.showMessageBox(error, "Failed", "success");
      });
    },
    showMessageBox(message, title, variant) {
      this.$bvModal
      .msgBoxOk(message, {
        title: title,
        size: "sm",
        buttonSize: "sm",
        okVariant: variant,
        centered: true
      })
      .then(value => {
      })
      .catch(err => {
      });
    }
  }
};
</script>

<style>
.filter-icon {
  margin-right: 11px;
  background-color: #e9e9e9;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  text-align: center;
  padding-top: 7px;
}

.action-button:hover {
  background-color: #f08045;
  border: 1px solid #f08045;
}
</style>